import isEqual from 'lodash/isEqual'

// ---------------------------------------
// Load fulltext literature if necessary
// ---------------------------------------
export function pubmed() {

  return async ( dispatch, getState, api ) => {

    const { xeon } = getState()
    // Refresh literature id if fulltext na
    const pmids = {}
    // Get rules with array pubmed list
    const rules = Object.values( xeon.rules )
    const ids = []
    for ( const rule of rules ) {
      if ( rule.pubmed && rule.pubmed.length > 0 ) {
        // Only 10 pmids per rule for now
        for ( const id of rule.pubmed.slice( 0, 10 ) ) {
          // Put on shopping list
          if ( !xeon.pmids || !xeon.pmids[ id ] ) {
            ids.push( id )
          }
          // Fulltext already in store
          else {
            pmids[ id ] = xeon.pmids[ id ]
          }
        }
      }
    }

    // Query only if necessary otherwise we get error
    if ( ids.length > 0 ) {
      try {
        // Inform interested view about loading
        // dispatch( { type: "view.loading", data: true } )

        const { meta, data } = await api.simple.list( {
          index: "pubmed",
          body: { ids }
        } )

        if ( meta.code == 200 && Array.isArray( data ) ) {
          for ( const item of data ) {
            if ( item ) {
              pmids[ item.id ] = item
            }
          }
        } else {
          console.log( "> data-thunk pubmed" )
          console.log( meta )
        }

      } catch ( e ) {
        console.log( "> Refresh of literature failed" )
        console.log( e )
      }

      // dispatch( { type: "view.loading", data: false } )
    }

    if ( !isEqual( xeon.pmids, pmids ) ) {
      dispatch( { type: "xeon.pmids", data: pmids } )
    }

    return Promise.resolve()
  }

}